import { FormattedMessage } from 'react-intl';

type SalesTieringProps = {
  shouldShowTiering: boolean;
};

/** Pill shown under an accumulator price when the quote comes from a sales tier. */
export const SalesTiering = ({ shouldShowTiering }: SalesTieringProps) => {
  if (!shouldShowTiering) {
    return null;
  }

  return (
    <div className="d-flex justify-content-center  w-100 mt-4px">
      <span
        className="badge rounded-pill badge-secondary fs-12"
        style={{ paddingTop: '2px', paddingBottom: '2px', bottom: '2px' }}
        data-e2e="sales-tiering"
      >
        <FormattedMessage id="tile.SaleTier" />
      </span>
    </div>
  );
};
